package info.rezident.app.core

fun String.isValidEmail() =
    "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
        .toRegex()
        .matches(this)